import { Util } from "app/utils";
import { ConsultRequestSummaryData } from "./ConsultRequestSummaryData";

export class ConsultRequestSummary {
    hasSummaries: boolean;
    hasRequest: boolean;
    hasComplete: boolean;
    hasLingoStatus: boolean;

    summaryDatas: ConsultRequestSummaryData[] = [];

    constructor(obj? : any) {
        if (obj === null || typeof obj === 'undefined') {
            return;
        }

        this.hasSummaries =  obj.hasSummaries;
        this.hasRequest = obj.hasRequest;
        this.hasComplete = obj.hasComplete;
        this.hasLingoStatus = obj.hasLingoStatus;
        
        if (obj.summaryDatas && obj.summaryDatas instanceof Array) {
            for (let data of obj.summaryDatas) {
                let summaryData: ConsultRequestSummaryData = new ConsultRequestSummaryData(data);
                this.summaryDatas.push(summaryData);
            }
        }
    }

}


// WEBPACK FOOTER //
// ./src/app/services/sales/model/ConsultRequestSummary.ts